export const GET_LOCATIONS_LIST = Symbol();
export const GET_LOCATIONS_LIST_SUCCESS = Symbol();
export const GET_LOCATIONS_LIST_ERROR = Symbol();

export const GET_SCHEMAS_LIST = Symbol();
export const GET_SCHEMAS_LIST_SUCCESS = Symbol();
export const GET_SCHEMAS_LIST_ERROR = Symbol();

export const GET_SCHEMA_DETAILS = Symbol();
export const GET_SCHEMA_DETAILS_SUCCESS = Symbol();
export const GET_SCHEMA_DETAILS_ERROR = Symbol();

export const GET_TAB_DETAILS = Symbol();
export const GET_TAB_DETAILS_SUCCESS = Symbol();
export const GET_TAB_DETAILS_ERROR = Symbol();

export const CLEAR_TAB_DETAILS = Symbol();
export const CLEAR_SCHEMA_DETAILS = Symbol();

export const GET_MACHINE_TYPES_LIST = Symbol();
export const GET_MACHINE_TYPES_LIST_SUCCESS = Symbol();
export const GET_MACHINE_TYPES_LIST_ERROR = Symbol();

export const SAVE_TAB_FORM = Symbol();
export const SAVE_TAB_FORM_SUCCESS = Symbol();
export const SAVE_TAB_FORM_ERROR = Symbol();

export const SAVE_SCHEMA_FORM = Symbol();
export const SAVE_SCHEMA_FORM_SUCCESS = Symbol();
export const SAVE_SCHEMA_FORM_ERROR = Symbol();

export const SELECT_SENSOR_PORT = Symbol();

export const SEARCH_SENSORS = Symbol();
export const SEARCH_SENSORS_SUCCESS = Symbol();
export const SEARCH_SENSORS_ERROR = Symbol();

export const GET_MACHINE_DETAILS = Symbol();
export const GET_MACHINE_DETAILS_SUCCESS = Symbol();
export const GET_MACHINE_DETAILS_ERROR = Symbol();

export const GET_MACHINE_NOTIFICATIONS = Symbol();
export const GET_MACHINE_NOTIFICATIONS_SUCCESS = Symbol();
export const GET_MACHINE_NOTIFICATIONS_ERROR = Symbol();

export const GET_MACHINE_LAST_TIME_IN_ALARM = Symbol();
export const GET_MACHINE_LAST_TIME_IN_ALARM_SUCCESS = Symbol();
export const GET_MACHINE_LAST_TIME_IN_ALARM_ERROR = Symbol();

export const GET_MACHINE_MAINTENANCE = Symbol();
export const GET_MACHINE_MAINTENANCE_SUCCESS = Symbol();
export const GET_MACHINE_MAINTENANCE_ERROR = Symbol();

export const CLEAR_MACHINE_DETAILS = Symbol();

export const TOGGLE_SENSOR = Symbol();

export const APP_INIT = Symbol();

export const UPDATE_FORM = Symbol();

export const FLIP = Symbol();
export const FLIP_MACHINE_DETAILS = Symbol();

export const TOGGLE_PUBLISH_MODAL= Symbol();

export const TOGGLE_MODIFY_PUBLISHED_MODAL= Symbol();

export const PUBLISH_SCHEMA = Symbol();
export const PUBLISH_SCHEMA_SUCCESS = Symbol();
export const PUBLISH_SCHEMA_ERROR = Symbol();

export const DELETE_SCHEMA = Symbol();
export const DELETE_SCHEMA_SUCCESS = Symbol();
export const DELETE_SCHEMA_ERROR = Symbol();

// export const CLONE_SCHEMA = Symbol();
export const CLONE_SCHEMA = "schema/clone-schema";
export const CLONE_SCHEMA_SUCCESS = Symbol();
export const CLONE_SCHEMA_ERROR = Symbol();

export const DELETE_TAB = Symbol();
export const DELETE_TAB_SUCCESS = Symbol();
export const DELETE_TAB_ERROR = Symbol();

export const CLONE_TAB = Symbol();
export const CLONE_TAB_SUCCESS = Symbol();
export const CLONE_TAB_ERROR = Symbol();

export const TOGGLE_SHOW_EDITOR_PROMT = Symbol();

export const TOGGLE_MACHINE_SOCKET = Symbol();
export const UPDATE_MACHINE_DETAILS = Symbol();

export const TOGGLE_TAB_SOCKET = Symbol();
export const UPDATE_TAB_DETAILS = Symbol();

export const TOGGLE_CURRENT_USER_SOCKET = Symbol();
export const ON_CURRENT_USER_NOTIFICATION = Symbol();

export const GET_SCHEMA_NOTIFICATIONS = Symbol();
export const GET_SCHEMA_NOTIFICATIONS_SUCCESS = Symbol();
export const GET_SCHEMA_NOTIFICATIONS_ERROR = Symbol();

export const GET_SENSORS_GRAPH = Symbol();
export const GET_SENSORS_GRAPH_SUCCESS = Symbol();
export const GET_SENSORS_GRAPH_ERROR = Symbol();

export const TOGGLE_FULL_SCREEN = Symbol();

export const GET_CURRENT_USER_NOTIFICATIONS = Symbol();
export const GET_CURRENT_USER_NOTIFICATIONS_SUCCESS = Symbol();
export const GET_CURRENT_USER_NOTIFICATIONS_ERROR = Symbol();

export const CHANGE_TABS_ORDER = Symbol();
export const CHANGE_TABS_ORDER_SUCCESS = Symbol();
export const CHANGE_TABS_ORDER_ERROR = Symbol();
